import { pb } from "../pocketbase/pocketbase";
import {
  Testimony,
  TestimonyFormData,
} from "../../core/testimony/entities/Testimony";
import { RepositoryInterface } from "../interfaces/RepositoryInterface";

function relationIds(value: unknown): string[] {
  if (!value || !Array.isArray(value)) return [];
  return value.map((item) =>
    typeof item === "string" ? item : (item as { id: string }).id,
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mapRecordToTestimony(record: any): Testimony {
  const related = relationIds(
    record.relatedTestimonieIds ??
    record.relatedTestimonyIds ??
    record.relatedTestimonies ??
    record.related_testimonies ??
    record.related_testimony,
  );

  return {
    id: record.id,
    trainingId: record.trainingId ?? record.training_id,
    title: record.title,
    subtitle: record.subtitle ?? "",
    description: record.description ?? null,
    image: pb.files.getURL(record, record.image) ?? null,
    videoLink: record.videoLink ?? record.video_link ?? null,
    text: record.text ?? null,
    tags: record.tags ?? [],
    keywords: record.keywords ?? [],
    relatedTestimonyIds: related,
    rank: record.rank,
    status: record.status,
    comments: record.comments ?? null,
  };
}

function testimonyFormToPayload(
  data: TestimonyFormData,
): Record<string, unknown> {
  const { relatedTestimonyIds, ...rest } = data;
  const payload: Record<string, unknown> = { ...rest };
  delete payload.image;
  if (relatedTestimonyIds !== undefined && relatedTestimonyIds !== null) {
    payload.relatedTestimonieIds = relatedTestimonyIds;
  }
  return payload;
}

export const testimonyRepository: RepositoryInterface<
  Testimony,
  TestimonyFormData
> = {
  async getAll(trainingId: string) {
    const records = await pb.collection("testimonies").getFullList({
      filter: `trainingId = "${trainingId}"`,
      sort: "rank",
    });

    return records.map(mapRecordToTestimony);
  },

  async getOne(id: string) {
    const record = await pb
      .collection("testimonies")
      .getOne(id.toString());

    return mapRecordToTestimony(record);
  },

  async addUpdate(data: TestimonyFormData, id: string | null) {
    const { image } = data;
    const payload = testimonyFormToPayload(data);

    if (image instanceof File) {
      payload.image = image;
    } else if (image === null || image === "") {
      payload.image = "";
    }

    let record;
    if (id) {
      record = await pb.collection("testimonies").update(
        id.toString(),
        payload,
      );
    } else {
      record = await pb.collection("testimonies").create(payload);
    }

    return mapRecordToTestimony(record);
  },

  async delete(id: string) {
    await pb.collection("testimonies").delete(id.toString());
  },

  async updateOrder(list: Testimony[]) {
    const updates = list.map((testimony, index) => ({
      id: testimony.id,
      rank: index + 1,
    }));

    await pb.send("/api/reorder", {
      method: "POST",
      body: {
        collection: "testimonies",
        data: updates,
      },
    });
  },
};
